import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useCustomTheme } from "../pages/LawyerPages/Settings/useTheme";

const SuspanceLoading = () => {
  const { themeConfig } = useCustomTheme();

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "0.5rem",
        }}
      >
        <Box sx={{ height: "5rem", width: "10rem" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 250 100"
          >
            <rect width="250" height="100" fill="none" />

            <text
              x="66.41"
              y="64.35"
              fontFamily="Corbel, sans-serif"
              fontWeight="bold"
              fontSize="44.76"
              fill={themeConfig.primaryColor}
            >
              LexMom
            </text>

            <g>
              <path
                d="M35.51 20.42c7.97,4.9 16.63,7.27 25.82,7.64 4.34,24.77 -5.75,40.64 -26.11,51.52 -21.42,-10.4 -30.05,-27.24 -26.22,-51.52 9.38,-0.54 18.26,-2.91 26.51,-7.64z"
                fill={themeConfig.primaryColor}
              />
              <path
                d="M49.27 38.94l1.98 -1.69c0.52,-0.44 1.37,-0.16 1.48,0.63 0.38,2.84 0.76,5.67 1.15,8.5 0.19,0.87 -0.14,1.34 -1.36,1.12l-6.98 -1.5c-1.57,-0.34 -3.33,-1.03 -1.44,-2.63l2.38 -2c-2.63,-3.83 -6.76,-5.94 -11.75,-5.94 -8.05,0 -14.57,6.52 -14.57,14.57 0,8.05 6.52,14.57 14.57,14.57 3.64,0 6.73,-1.53 9.16,-3.84 2.4,-2.27 4.16,-5.3 5.19,-8.36 0.73,-2.12 4.48,-1.1 4.08,1.04 -1.64,8.38 -9.58,14.8 -18.43,14.8 -10.06,0 -18.21,-8.15 -18.21,-18.21 0,-10.06 8.15,-18.21 18.21,-18.21 6.09,0 11.24,2.56 14.54,7.15z"
                fill="#ffffff"
              />
            </g>
          </svg>
        </Box>

        {/* Spinner */}
        <CircularProgress
          size={45}
          thickness={4}
          sx={{
            color: themeConfig.primaryColor, // 🎨 spinner matches theme
          }}
        />
      </Box>
    </Box>
  );
};

export default SuspanceLoading;
